import {Route, Routes} from '@angular/router';
import {CoreSubRoutes} from "./core/core.route";
import {DsSubRoutes} from "./ds/ds.route";
import {ObSubRoutes} from "./ob/ob.route";
import {RgSubRoutes} from "./rg/rg.route";
import {UsSubRoutes} from "./us/us.route";
import {AppComponent} from "./app.component";
import {CiSubRoutes} from "./ci/ci.route";
import {CsSubRoutes} from "./cs/cs.route";


export function getMvsaRouters() : {name: string, routeMethod: () => Routes}[] {

  const modules : {name: string, routeMethod: () => Routes}[] =
    [
      {name : "core", routeMethod: CoreSubRoutes},
      {name : "ds", routeMethod: DsSubRoutes},
      {name : "ci", routeMethod: CiSubRoutes},
      {name : "ob", routeMethod: ObSubRoutes },
      {name : "rg", routeMethod: RgSubRoutes },
      {name : "us", routeMethod: UsSubRoutes },
      {name : "cs", routeMethod: CsSubRoutes },
    ];

  return modules;

}


function collectSubRoutes(): Route[] {

  let routes : Route[] =     [
    // {path: '', component: HomePagePage},
  ];

  // collect all routes
  const mvsaRouters = getMvsaRouters();

  if (mvsaRouters) {
    for (let mvsaRouter of mvsaRouters) {

      const subRoutes = mvsaRouter.routeMethod();

      if (subRoutes) {
        for (let subRoute of subRoutes) {

          // add guard
          /*
          if (!environment.useApiTicket) {
            if (subRoute.canActivate) {
              subRoute.canActivate.push(MsalGuard);
            } else {
              subRoute.canActivate = [MsalGuard];
            }
          }
           */

          routes.push(subRoute);
        }
      }

    }
  }

  return routes;

}

export const routes: Routes =
  [
    {
      path: '', component: AppComponent,
      children: collectSubRoutes()
    },

    {path: '**', redirectTo: '/notfound'},
  ];


// export const routes: Routes = [];
